import api, {graphqlQueryBuild} from '.';

export const loadHomeAsync = async (watchedVideos, rating) => {
    //let query = `{comics(language: ${locale.toUpperCase()}) { id show title subtitle about baseUrl friendlyName logo cover characters englishTitle chapters { id number cover releaseDate folder images }}}`;

    let query = graphqlQueryBuild(
        'homeRows',
        `
            title
            vods {
                id
                title
                image
                duration
                episode
                season
                description
                externalId

                show {
                    title
                }
            }`,
        `ids: [${watchedVideos}], age:${rating}`,
    );

    let response = await api.get('', {
        params: {
            query,
        },
    });

    if (response.data && response.data.data?.homeRows) {
        return response.data.data.homeRows;
    }
    throw new Error('Home rows load failed');
};
